import React from 'react';
import Heading from 'components/common/heading/heading';
import Panel from 'components/common/panel/panel';
import Datatable from 'components/common/datatable/datatable';
import Pager from 'components/common/pager/pager';

export default function DataTestPage(props) {
  return (
    <>
      <Heading>
        <div>
          <a href='/Developers/Test/Components' className='btn btn-link'>View Components Test</a>
          <div className='btn btn-none text-dark text-thick'>Data Test</div>
          <a href='/Developers/Test/Forms' className='btn btn-link'>View Forms Test</a>
          <a href='/Developers/Test/Modals' className='btn btn-link'>View Modals Test</a>
        </div>
      </Heading>

      <div className='row justify-content-center mx-0 mt-4'>
        <div className='col-md-12 col-xl-10'>

          <Panel>
            <Panel.Header>Datatable (Basic)</Panel.Header>
            <Panel.Body>
              <Datatable columns={basicColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Datatable (Sticky)</Panel.Header>
            <Panel.Body>
              <Datatable columns={stickyColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Datatable (Align)</Panel.Header>
            <Panel.Body>
              <Datatable columns={alignColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Datatable (Selectable)</Panel.Header>
            <Panel.Body>
              <Datatable columns={selectableColumns} data={data} />
              <hr className='my-4' />
              <Datatable columns={selectablePlusStickyColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Datatable (Growth)</Panel.Header>
            <Panel.Body>
              <Datatable columns={growthColumns} data={data} />
              <hr className='my-4' />
              <Datatable columns={growthCompactColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Datatable (Grouped)</Panel.Header>
            <Panel.Body>
              <Datatable columns={groupedColumns} data={data} />
              <hr className='my-4' />
              <Datatable columns={groupedPlusStickyColumns} data={data} />
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Pagers</Panel.Header>
            <Panel.Body>
              <Pager className='mb-1' align='left' active={1} pages={2} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={1} pages={3} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={1} pages={4} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={1} pages={5} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={1} pages={6} onChange={(page) => null} />
              <hr />
              <Pager className='mb-1' align='left' active={8} pages={8} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={7} pages={8} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={6} pages={8} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={5} pages={8} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={4} pages={8} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={3} pages={8} onChange={(page) => null} />
              <hr />
              <Pager className='mb-1' align='left' active={4} pages={50} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={23} pages={50} onChange={(page) => null} />
              <Pager className='mb-1' align='left' active={46} pages={50} onChange={(page) => null} />
            </Panel.Body>
          </Panel>

          <div>
            TODO
            <ol>
              <li>Add column sorting</li>
            </ol>
          </div>

        </div>
      </div>
    </>
  );
}


const basicColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
  },
  {
    Header: 'Status',
    accessor: 'swStatus',
    badge: [
      {
        equals: 'Good',
        color: '#008000',
        textColor: '#ffffff',
      },
      {
        equals: 'Warning',
        color: '#ea901f',
        textColor: '#ffffff',
      },
      {
        equals: 'Error',
        color: '#c52f2f',
        textColor: '#ffffff',
      }
    ],
  },
  {
    Header: 'Version',
    accessor: 'swVersion',
    indicator: [
      {
        equals: '8.13.1',
        color: '#008000',
      },
      {
        equals: '8.12.4',
        color: '#ea901f',
      },
      {
        equals: '8.12.3',
        color: '#c52f2f',
      }
    ],
  },
  {
    Header: 'Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Progress',
    accessor: 'progress',
    progress: [
      {
        start: 0,
        end: 25,
        color: '#ed5565',
      },
      {
        start: 26,
        end: 50,
        color: '#f8ac59',
      },
      {
        start: 51,
        end: 75,
        color: '#23c6c8',
      },
      {
        start: 76,
        end: 99,
        color: '#1c84c6',
      },
      {
        start: 100,
        end: 100,
        color: '#1ab394',
      },
    ],
  },
  {
    Header: 'Connection',
    accessor: 'connection',
    progressBlocks: [
      {
        value: 1,
        color: '#ed5565',
      },
      {
        value: 2,
        color: '#f8ac59',
      },
      {
        value: 3,
        color: '#23c6c8',
      },
      {
        value: 5,
        color: '#1c84c6',
      },
      {
        value: 6,
        color: '#1ab394',
      },
    ],
  },
];

const stickyColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    sticky: 'left',
    width: 220,
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 400,
    maxWidth: 600,
  },
  {
    Header: 'Count',
    accessor: 'integerData',
  },
  {
    Header: 'Amount',
    accessor: 'floatData',
  },
  {
    Header: 'Dollars',
    accessor: 'dollarData',
    sticky: 'right',
  },
  {
    Header: 'Date',
    accessor: 'dateData',
    sticky: 'right',
  },
];

const alignColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
    align: 'right',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
    align: 'center',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
    align: 'right',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
    align: 'right',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
    align: 'right',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 400,
    maxWidth: 600,
    align: 'left',
  },
  {
    Header: 'Count',
    accessor: 'integerData',
    align: 'right',
  },
  {
    Header: 'Amount',
    accessor: 'floatData',
    align: 'right',
  },
  {
    Header: 'Dollars',
    accessor: 'dollarData',
    align: 'right',
  },
  {
    Header: 'Date',
    accessor: 'dateData',
    align: 'center',
  },
];

const growthColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 300,
    grow: true,
  },
  {
    Header: 'Count',
    accessor: 'integerData',
  },
];

const growthCompactColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 300,
    grow: true,
  },
  {
    Header: 'Count',
    accessor: 'integerData',
  },
  {
    Header: 'Amount',
    accessor: 'floatData',
  },
  {
    Header: 'Dollars',
    accessor: 'dollarData',
  },
  {
    Header: 'Date',
    accessor: 'dateData',
  },
];

const selectableColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
    checkbox: {
      variant: 'success',
    },
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 400,
  },
  {
    Header: 'Count',
    accessor: 'integerData',
  },
  {
    Header: 'Amount',
    accessor: 'floatData',
  },
  {
    Header: 'Dollars',
    accessor: 'dollarData',
  },
  {
    Header: 'Date',
    accessor: 'dateData',
  },
];

const selectablePlusStickyColumns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
    sticky: 'left',
    checkbox: {
      variant: 'success',
    },
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 400,
  },
  {
    Header: 'Count',
    accessor: 'integerData',
  },
  {
    Header: 'Amount',
    accessor: 'floatData',
  },
  {
    Header: 'Dollars',
    accessor: 'dollarData',
  },
  {
    Header: 'Date',
    accessor: 'dateData',
  },
];

const groupedColumns = [
  {
    Header: 'Site Info',
    group: true,
    columns: [
      {
        Header: 'Site',
        accessor: 'storeName',
        width: 220,
      },
      {
        Header: 'Indentifier',
        accessor: 'storeId',
      },
    ],
  },
  {
    Header: 'Agent Info',
    group: true,
    columns: [
      {
        Header: 'Agent Version',
        accessor: 'swVersion',
      },
      {
        Header: 'Agent Build Date',
        accessor: 'swBuildDate',
      },
    ],
  },
  {
    Header: 'Mozart Info',
    group: true,
    columns: [
      {
        Header: 'Payments Version',
        accessor: 'hwVersion',
      },
      {
        Header: 'Mozart Agent Version',
        accessor: 'mzAgentVersion',
      },
      {
        Header: 'Mozart Plugin Version',
        accessor: 'mzPluginVersion',
      },
    ],
  },
  {
    Header: 'Operating System',
    group: true,
    columns: [
      {
        Header: 'Operating System',
        accessor: 'osName',
        width: 400,
      },
    ],
  },
  {
    Header: 'Data Types',
    group: true,
    columns: [
      {
        Header: 'Count',
        accessor: 'integerData',
      },
      {
        Header: 'Amount',
        accessor: 'floatData',
      },
      {
        Header: 'Dollars',
        accessor: 'dollarData',
      },
      {
        Header: 'Date',
        accessor: 'dateData',
      },
    ],
  },
];

const groupedPlusStickyColumns = [
  {
    Header: 'Site Info',
    group: true,
    sticky: 'left',
    columns: [
      {
        Header: 'Site',
        accessor: 'storeName',
        width: 220,
      },
      {
        Header: 'Indentifier',
        accessor: 'storeId',
      },
    ],
  },
  {
    Header: 'Agent Info',
    group: true,
    columns: [
      {
        Header: 'Agent Version',
        accessor: 'swVersion',
      },
      {
        Header: 'Agent Build Date',
        accessor: 'swBuildDate',
      },
    ],
  },
  {
    Header: 'Mozart Info',
    group: true,
    columns: [
      {
        Header: 'Payments Version',
        accessor: 'hwVersion',
      },
      {
        Header: 'Mozart Agent Version',
        accessor: 'mzAgentVersion',
      },
      {
        Header: 'Mozart Plugin Version',
        accessor: 'mzPluginVersion',
      },
    ],
  },
  {
    Header: 'Operating System',
    group: true,
    columns: [
      {
        Header: 'Operating System',
        accessor: 'osName',
        width: 400,
      },
    ],
  },
  {
    Header: 'Data Types',
    group: true,
    sticky: 'right',
    columns: [
      {
        Header: 'Count',
        accessor: 'integerData',
      },
      {
        Header: 'Amount',
        accessor: 'floatData',
      },
      {
        Header: 'Dollars',
        accessor: 'dollarData',
      },
      {
        Header: 'Date',
        accessor: 'dateData',
      },
    ],
  },
];




const data = [
  {
    storeId: 3124,
    storeName: 'Store 414 - Sanford',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 7 Professional',
    progress: 22,
    connection: 3,
    integerData: 84,
    floatData: 789.679,
    dollarData: '$325.14',
    dateData: '09/09/2019',
  },
  {
    storeId: 43,
    storeName: 'Store 419 - Clermont',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 93,
    connection: 4,
    integerData: 983,
    floatData: 543.3444387,
    dollarData: '$64.32',
    dateData: '12/21/2019',
  },
  {
    storeId: 3455,
    storeName: 'Store 421 - Orlando (Hunter\'s Creek)',
    swStatus: 'Warning',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 77,
    connection: 2,
    integerData: 12983,
    floatData: 42343.7455,
    dollarData: '$3.12',
    dateData: '06/01/2020',
  },
  {
    storeId: 3028,
    storeName: 'Store 423 - Orlando (Lake Nona)',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 7 Professional',
    progress: 62,
    connection: 0,
    integerData: 5,
    floatData: 65.234,
    dollarData: '$412.54',
    dateData: '08/21/2020',
  },
  {
    storeId: 6,
    storeName: 'Store 424 - WATERFORD/UCE',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 50,
    connection: 6,
    integerData: 23,
    floatData: 5.5,
    dollarData: '$123.76',
    dateData: '03/23/2020',
  },
  {
    storeId: 862,
    storeName: 'Store 425 - Alamonte Springs',
    swStatus: 'Warning',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 7,
    connection: 4,
    integerData: 9675,
    floatData: 5243.854,
    dollarData: '$5.12',
    dateData: '08/03/2020',
  },
  {
    storeId: 2373,
    storeName: 'Store 427 - Winter Park',
    swStatus: 'Warning',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 100,
    connection: 5,
    integerData: 51,
    floatData: 34432.3,
    dollarData: '$523.87',
    dateData: '07/08/2020',
  },
  {
    storeId: 9372,
    storeName: 'Store 501 - Tenders',
    swStatus: 'Good',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 46,
    connection: 2,
    integerData: 745,
    floatData: 32.543,
    dollarData: '$5423.76',
    dateData: '07/07/2020',
  },
  {
    storeId: 112,
    storeName: 'Store 505 - Wake Forest',
    swStatus: 'Error',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 7 Professional',
    progress: 14,
    connection: 1,
    integerData: 236,
    floatData: 756.412,
    dollarData: '$42.23',
    dateData: '05/15/2020',
  },
  {
    storeId: 78,
    storeName: 'Store 506 - Falls of Neuse',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise LTSC',
    progress: 88,
    connection: 5,
    integerData: 932,
    floatData: 634.5236,
    dollarData: '$234.54',
    dateData: '01/31/2020',
  },
  {
    storeId: 1454,
    storeName: 'Store 507 - Concrd Mills',
    swStatus: 'Good',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 33,
    connection: 0,
    integerData: 77,
    floatData: 2.5542,
    dollarData: '$4324.77',
    dateData: '11/11/2019',
  },
  {
    storeId: 875,
    storeName: 'Store 508 - Cary',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 99,
    connection: 6,
    integerData: 0,
    floatData: 3.883,
    dollarData: '$43.86',
    dateData: '10/31/2020',
  },
  {
    storeId: 123,
    storeName: 'Store 509 - Columbia',
    swStatus: 'Good',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.6.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 0,
    connection: 4,
    integerData: 11,
    floatData: 28.979,
    dollarData: '$0.00',
    dateData: '06/15/2020',
  },
  {
    storeId: 7732,
    storeName: 'Store 511 - Hickory',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 29,
    connection: 5,
    integerData: 5326,
    floatData: 8864.4445,
    dollarData: '$5.01',
    dateData: '12/25/2019',
  },
  {
    storeId: 5132,
    storeName: 'Store 512 - Durham',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 55,
    connection: 1,
    integerData: 3,
    floatData: 44.99,
    dollarData: '$7.42',
    dateData: '02/22/2020',
  },
  {
    storeId: 776,
    storeName: 'Store 513 - Greenville',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 7 Professional',
    progress: 37,
    connection: 4,
    integerData: 99,
    floatData: 1.656,
    dollarData: '$155.98',
    dateData: '07/30/2020',
  },
  {
    storeId: 2167,
    storeName: 'Store 514 - Winston-Salem',
    swStatus: 'Good',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise LTSC',
    progress: 100,
    connection: 6,
    integerData: 842,
    floatData: 115.543,
    dollarData: '$43.00',
    dateData: '04/01/2020',
  },
];